// src/components/FeaturesSection.jsx
import React from 'react';
import { FaWifi, FaCarBattery, FaBed, FaConciergeBell } from 'react-icons/fa';
import './FeaturesSection.css';

const FeaturesSection = () => {
  return (
    <div className="features-section">
      <div className="feature">
        <FaWifi size={40} />
        <p>Free WiFi</p>
      </div>
      <div className="feature">
        <FaBed size={40} />
        <p>Fully Furnished</p>
      </div>
      <div className="feature">
        <FaCarBattery size={40} />
        <p>Power Backup</p>
      </div>
      <div className="feature">
        <FaConciergeBell size={40} />
        <p>Cleaning Services</p>
      </div>
    </div>
  );
};

export default FeaturesSection;
